import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { PromotionsVmRewards, PromotionVm } from '@inyova/models';

@Component({
  selector: 'app-account-promotion',
  templateUrl: './account-promotion.component.html',
  styleUrls: ['./account-promotion.component.scss'],
  standalone: false
})
export class AccountPromotionComponent implements OnInit {
  @Input() vm: PromotionVm;
  @Output() showPromotionsModal: EventEmitter<void> = new EventEmitter<void>();
  @Output() inviteFriends: EventEmitter<{ promo: PromotionsVmRewards; currency: string; referralCode: string }> = new EventEmitter<{
    promo: PromotionsVmRewards;
    currency: string;
    referralCode: string;
  }>();

  @Output() copyToClipboard: EventEmitter<{ source: 'link' | 'code'; content: string }> = new EventEmitter<{
    source: 'link' | 'code';
    content: string;
  }>();

  termsLink: string;
  info = {
    promotionInfo: false,
    freeInvestingMonths: false,
    moneyMonthlyDesc: false,
    pendingMoney: false,
    pendingMonths: false
  };

  ngOnInit() {
    this.termsLink = this.getTermsLink(this.vm.language);
  }

  toggleInfo(item: string) {
    this.info[item] = !this.info[item];
  }

  onCopyToClipboard(source: 'link' | 'code') {
    const content = source === 'link' ? `https://app.inyova.${this.vm.appLocation}/invite/${this.vm.referralCode}` : this.vm.referralCode;
    this.copyToClipboard.emit({ source, content });
  }

  onShowPromotionsModal() {
    this.showPromotionsModal.emit();
  }

  onInviteFriends(promo: PromotionsVmRewards, currency: string, referralCode: string) {
    this.inviteFriends.emit({ promo, currency, referralCode });
  }

  getTermsLink(language: string) {
    switch (language) {
      case 'en-CH':
        return `https://help.inyova.ch/hc/en-us/articles/4417882819730-Inyova-promotions`;
      case 'en-DE':
        return `https://help.inyova.de/hc/en-us/articles/4417905274642-Inyova-promotions`;
      case 'fr-CH':
        return `https://help.inyova.ch/hc/fr/articles/4417882819730-Promotions-Inyova`;
      case 'de-CH':
        return `https://help.inyova.ch/hc/de/articles/4417882819730-Inyova-Aktionen`;
      case 'de-DE':
        return `https://help.inyova.de/hc/de/articles/4417905274642-Inyova-Aktionen`;
    }
  }
}
